import { actions } from '../constants'

const initialState = {
  loading: false,
  showCurrentGraphic: true,
}

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actions.FETCH:
      return {
        ...state,
        loading: true,
      }

    case actions.TOGGLE_SHOW_OLD_GRAPHIC:
      return {
        ...state,
        showCurrentGraphic: payload.showCurrentGraphic,
      }

    case actions.FETCH_SUCCESS:
    case actions.FETCH_FAILURE:
      return {
        ...state,
        loading: false,
      }

    default:
      return state
  }
}

export default reducer
